'use client'

import { Input } from '@/components/Search/Search'
import { useSearch } from '../Search/SearchProvider'

export function SearchBar ({ placeholder }: { placeholder: string }) {
  const setQuery = useSearch((state) => state.setQuery)

  return (
    <Input
      placeholder={placeholder}
      onChange={(event) => { setQuery(event.currentTarget.value) }}
      style={{ borderRadius: 13, maxWidth: 'unset' }}
    />
  )
}
